var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-radio-group',{staticClass:"radio-list",staticStyle:{"height":"100%"},attrs:{"id":_vm.def.guid,"chain":_vm.def.chain},model:{value:(_vm.def.val),callback:function ($$v) {_vm.$set(_vm.def, "val", $$v)},expression:"def.val"}},[_c('div',{staticClass:"h-100 w-100 d-flex"},_vm._l((_vm.def.vals),function(ref){
var key = ref.key;
var lbl = ref.lbl;
var lblHead = ref.lblHead;
return _c('b-form-radio',{key:key,attrs:{"value":key}},[(lblHead)?_c('strong',[_vm._v(_vm._s(lblHead))]):_vm._e(),_vm._v(_vm._s(lbl)+" ")])}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }